import { createGlobalState } from '@vueuse/core'
import { ref } from 'vue'

export const useAppHider = createGlobalState(() => {
  const hidden = ref(false)

  function hide () {
    hidden.value = true
  }

  function show () {
    hidden.value = false
  }

  return {
    hidden,
    hide,
    show,
  }
})
